import React from 'react'
import './localizedText.scss'

// What a list marks of a text block that needs attention (ADR 0013), as the API reads it (`translationAttention`): its translation runs,
// its language waits for its author, or the translation failed and waits for one written by hand. `blockName` names the block; the marker
// offers no action, which belongs in the editor.
const MARKERS = {
  pending: ['badge-soft-info', 'bx-loader-alt', 'Translating'],
  languageMismatch: ['badge-soft-warning', 'bx-error', 'Check the original language'],
  blocked: ['badge-soft-danger', 'bx-error', 'Manual translation required'],
}

export default function TranslationMarker({ attention, blockName }) {
  if (!MARKERS[attention]) return null
  const [tone, icon, label] = MARKERS[attention]
  return <span className={'badge translation-marker ' + tone}><i className={'bx ' + icon} aria-hidden="true" />{label} · {blockName}</span>
}

// The states a row's markers show first: those that wait for someone before the one that only runs.
const MARKER_STATE_ORDER = ['blocked', 'languageMismatch', 'pending']
// A row's markers of its blocks that need attention (`attention`, each block's state by its name), one for each state, naming its blocks in
// the order of `blocks` (each block's name with its label): "Manual translation required · Player package", "Translating · Description".
export function TranslationMarkers({ attention, blocks }) {
  const markers = MARKER_STATE_ORDER.map(state => [state, blocks.filter(([name]) => attention?.[name] === state).map(([, label]) => label)])
    .filter(([, labels]) => labels.length)
  if (!markers.length) return null
  return <span className="translation-markers">{markers.map(([state, labels]) =>
    <TranslationMarker key={state} attention={state} blockName={labels.join(', ')} />)}</span>
}
